import Panel from "./Panel.vue";
import PanelGrid from "./PanelGrid.vue";
import { pluginify } from "./../../util";
export default pluginify(Panel, PanelGrid);
export { Panel, PanelGrid };
